import {Component, OnInit, NgZone, OnDestroy} from '@angular/core';
import {Chart} from 'angular-highcharts';
import {DataService} from '../../services/data.service';
import { Subscription} from 'rxjs';
declare var $: any;

export interface PeriodicElement {
  name: number;
  position: string;
  weight: number;
}
const ELEMENT_DATA: PeriodicElement[] = [
  {position: 'Detected Fraud', name: 18, weight: 12.5},
  {position: 'Detected No Fraud', name: 9.5, weight: 60},
];

@Component({
  selector: 'app-fraud-incident-types',
  templateUrl: './fraud-incident-types.component.html',
  styleUrls: ['./fraud-incident-types.component.scss']
})
export class FraudIncidentTypesComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['position', 'name', 'weight'];
  orignalOutcome: any;
  predictedOutcome: any;
  index: any;
  observable: Subscription;
  outcomes = [['Not Fraud', 'Fraud'], ['Fraud', 'Not Fraud'], ['Fraud', 'Fraud'], ['Fraud', 'Fraud'], ['Fraud', 'Fraud'],
    ['Not Fraud', 'Fraud'], ['Fraud', 'Not Fraud'], ['Fraud', 'Fraud'], ['Not Fraud', 'Not Fraud'], ['Not Fraud', 'Not Fraud']
  ];
  dataSource = ELEMENT_DATA;
  refreshChart: any;
  chart: any;
  constructor(private dataService: DataService, private zone: NgZone) {
    this.refreshChart = false;
  }

  ngOnInit() {
    this.observable = this.dataService.selectedDropValue.subscribe( data => { this.showData(data); });
    this.orignalOutcome = this.outcomes[0][0];
    this.predictedOutcome = this.outcomes[0][1];
    $('.outcome-result--orignal').css({ 'color' : 'green'});
    $('.outcome-result--predicted').css({ 'color' : 'red'});
  }
  ngOnDestroy() {
    this.observable.unsubscribe();
  }
  showData(data) {
    this.orignalOutcome = [];
    this.predictedOutcome = [];
    this.index = data['value'] - 1;
    this.orignalOutcome = this.outcomes[this.index][0];
    this.predictedOutcome = this.outcomes[this.index][1];
    if (this.orignalOutcome === 'Fraud') {
      $('.outcome-result--orignal').css({ 'color' : 'red'});
    } else {
      $('.outcome-result--orignal').css({ 'color' : 'green'});
    }
    if (this.predictedOutcome === 'Fraud') {
      $('.outcome-result--predicted').css({ 'color' : 'red'});
    } else {
      $('.outcome-result--predicted').css({ 'color' : 'green'});
    }
  }
}
